import React, { useState } from 'react';

interface TournamentScheduleProps {
  defaultOpen?: boolean;
}

const TournamentSchedule: React.FC<TournamentScheduleProps> = ({ defaultOpen = false }) => {
  const [scheduleOpen, setScheduleOpen] = useState(defaultOpen);

  return (
    <>
      <style>{`
        .schedule-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1rem;
          margin-bottom: 1.5rem;
        }

        @media (min-width: 768px) {
          .schedule-grid {
            grid-template-columns: 1fr 1fr 1fr;
          }
        }

        .schedule-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 0.9rem;
        }

        .schedule-table th {
          color: rgba(255, 255, 255, 0.9);
          padding: 0.5rem 0.75rem;
          border-bottom: 1px solid rgba(255, 255, 255, 0.2);
          text-align: left;
          font-weight: 600;
        }

        .schedule-table td {
          color: rgba(255, 255, 255, 0.8);
          padding: 0.4rem 0.75rem;
          border-bottom: 1px solid rgba(255, 255, 255, 0.07);
        }
      `}</style>

      <div
        style={{
          background: 'rgba(255, 255, 255, 0.08)',
          borderRadius: '15px',
          padding: '1rem 1.5rem',
          border: '1px solid rgba(255, 255, 255, 0.15)',
          marginBottom: '2rem',
          cursor: 'pointer',
        }}
        onClick={() => setScheduleOpen(!scheduleOpen)}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}>
          <h4 style={{ color: '#fff', margin: 0, fontSize: '1.25rem' }}>
            <i className="bi bi-calendar-week me-2"></i>
            Tournament Schedule
          </h4>
          <span style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '0.85rem' }}>
            — Saturday 6th &amp; Sunday 7th June 2026
          </span>
          <i
            className={`bi bi-chevron-${scheduleOpen ? 'up' : 'down'}`}
            style={{ color: 'rgba(255, 255, 255, 0.7)', marginLeft: '0.5rem' }}
          ></i>
        </div>

        {scheduleOpen && (
          <div style={{ marginTop: '1.25rem' }} onClick={(e) => e.stopPropagation()}>
            <div className="schedule-grid">
              <div>
                <h5 style={{ color: '#fff', fontSize: '1rem', marginBottom: '0.5rem' }}>Boys / Mixed</h5>
                <table className="schedule-table">
                  <thead>
                    <tr><th>Age</th><th>Day</th><th>Session</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>U7</td><td>Sat</td><td>Afternoon</td></tr>
                    <tr><td>U8</td><td>Sat</td><td>Morning</td></tr>
                    <tr><td>U9</td><td>Sun</td><td>Morning</td></tr>
                    <tr><td>U10</td><td>Sat</td><td>Morning</td></tr>
                    <tr><td>U11</td><td>Sun</td><td>Afternoon</td></tr>
                    <tr><td>U12</td><td>Sat</td><td>Afternoon</td></tr>
                    <tr><td>U13</td><td>Sun</td><td>Afternoon</td></tr>
                    <tr><td>U14</td><td>Sat</td><td>Afternoon</td></tr>
                    <tr><td>U15</td><td>Sun</td><td>Morning</td></tr>
                  </tbody>
                </table>
              </div>

              <div>
                <h5 style={{ color: '#fff', fontSize: '1rem', marginBottom: '0.5rem' }}>Girls</h5>
                <table className="schedule-table">
                  <thead>
                    <tr><th>Age</th><th>Day</th><th>Session</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>U10 Girls</td><td>Sat</td><td>Morning</td></tr>
                    <tr><td>U12 Girls</td><td>Sat</td><td>Morning</td></tr>
                    <tr><td>U15 Girls</td><td>Sat</td><td>Morning</td></tr>
                  </tbody>
                </table>
              </div>

              <div>
                <h5 style={{ color: '#fff', fontSize: '1rem', marginBottom: '0.5rem' }}>Invitationals</h5>
                <table className="schedule-table">
                  <thead>
                    <tr><th>Team</th><th>Day</th><th>Session</th></tr>
                  </thead>
                  <tbody>
                    <tr><td>U16 Park</td><td>Sun</td><td>Afternoon</td></tr>
                    <tr><td>U16 Royals</td><td>Sun</td><td>Afternoon</td></tr>
                    <tr><td>U16 Girls</td><td>Sat</td><td>Morning</td></tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div
              style={{
                background: 'rgba(255, 255, 255, 0.05)',
                borderRadius: '10px',
                padding: '1rem 1.25rem',
                border: '1px solid rgba(255, 255, 255, 0.1)',
              }}
            >
              <h5 style={{ color: '#fff', fontSize: '1rem', marginBottom: '0.5rem' }}>
                <i className="bi bi-people-fill me-2"></i>Formats
              </h5>
              <div style={{ color: 'rgba(255, 255, 255, 0.8)', fontSize: '0.9rem', display: 'grid', gap: '0.25rem' }}>
                <div><strong>U7s and U8s:</strong> Team size 5 &middot; Squad size 8 max</div>
                <div><strong>U9–U11:</strong> Team size 7 &middot; Squad size 10 max</div>
                <div><strong>U12–U15:</strong> Team size 6 &middot; Squad size 9 max</div>
                <div><strong>U16 / U16 Girls:</strong> Team size 6 &middot; Squad size 9 max</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default TournamentSchedule;
